"use client";

import {Box, Text} from "@chakra-ui/react";
import {Container} from "../../../components/Container";
import Heading from "../../../components/Heading";
import {ChatBubbleBottomCenterTextIcon, DocumentArrowUpIcon, MagnifyingGlassIcon} from "@heroicons/react/20/solid";
import {FeatureCarousel, FeatureT} from "../../../components/FeatureCarousel";
import CTAButton from "../../../components/CTAButton";

import ScreenshotResponseWizard from "./images/response-wizard.png";
import ScreenshotSpreadsheetImport from "./images/spreadsheet-import.png";
import ScreenshotFacts from "./images/facts.png";

const features: FeatureT[] = [
  {
    summary: "AI-powered, self maintaining knowledge base",
    description:
      "Automatically builds and maintains your knowledge base of facts with information from your whole organization, surfacing any stale or conflicting information",
    image: ScreenshotFacts,
    icon: MagnifyingGlassIcon,
  },
  {
    summary: "Import and export in any format - including portals",
    description:
      "Platformed handles any format you throw at it, both online portals and offline documents. From spreadsheets to word documents, and PDFs to online portals",
    image: ScreenshotSpreadsheetImport,
    icon: DocumentArrowUpIcon,
  },
  {
    summary: "Consistent, automatically generated responses",
    description:
      "Using your knowledge base, our AI generates responses with a full evidence chain. Enjoy the freedom of setting up custom prompts, word count limits, and more",
    image: ScreenshotResponseWizard,
    icon: ChatBubbleBottomCenterTextIcon,
  },
];

const SecondaryFeatures = () => (
  <Box
    as="section"
    id="secondary-features"
    aria-label="Features for simplifying everyday business tasks"
    pt={[20, 32]}
    pb={[14, 20, 20, 32]}
  >
    <Container>
      <Box mx="auto" maxW={["4xl"]} textAlign={[null, null, "center"]} mb={16}>
        <Heading size={["2xl", "2xl", "2xl", "3xl"]} pb="1" color="gray.700">
          How it Works:{" "}
          <Text
            as="span"
            color="blue.200"
            bgGradient={"linear-gradient(170deg, {colors.pink.400}, {colors.purple.500})"}
            backgroundClip="text"
          >
            Seamless, Smart Questionnaire Automation
          </Text>
        </Heading>
        <Text mt={4} color="gray.700" fontSize="md">
          Platformed is purpose-built for speed, accuracy, and scale, powered by real AI that actually understands your
          content. Spend less time answering questionnaires and more time closing deals.
        </Text>
      </Box>
      <FeatureCarousel features={features} colorPalette="pink" />
      <Box pt={8} textAlign="center">
        <CTAButton
          href="#book-a-demo"
          colorPalette="pink"
          bgGradient="linear-gradient(135deg, {colors.pink.500}, {colors.pink.600}, {colors.purple.600})"
          _hover={{
            bgGradient: "linear-gradient(135deg, {colors.pink.600}, {colors.pink.700}, {colors.purple.700})",
          }}
        >
          Sign up to see Platformed in action
        </CTAButton>
      </Box>
    </Container>
  </Box>
);

export default SecondaryFeatures;
